var geoDebug = false;
var debug = false;
var errMsgCopy = 'No results found. Please try again'
var firstLoad = true;
var BingMapKey = bingMapsAPIKey;






function zipToString(zip) {
    var strZip = (zip || '').toString();
    if (strZip.length > 0 && strZip.length < 5) {
        strZip = ('0000' + strZip).substring(4 + strZip.length - 5);
    }
    return strZip;
}


// 3 start -----------------------------------------------------------------------------

var DealerLocator = function() {
    this._vars = {
        //isLoading: true,
        map: 'xxxx',
        infobox: null,
        pushpins: [],
        //isRangeSliderChanging: null,
        //rangeChangeTimeout: null,
        //lastZoomLevel: null,
        userChangedZoom: false,
        pinIcon: '/public/images/dealer-locator/map-pin.png',
        pinIconActive: '/public/images/dealer-locator/map-pin-active.png'
    };

    var _vars = this._vars;

    // Elements
    this._elements = {
        mapPanel: document.getElementsByClassName('map-panel')[0]
    };

    this.initPage = function(zip) {
        dl.initMap(function() {

            //if zip value present, then load data
            //otherwise wait for zipcode to become available

            zip = ngScope().tZip.inputZip || zip;
            if (zip) {
                dl_getLatLon(zip, function(lat, lon) {

                    //tracking
                    callFloodlight('dealer-locator-results');

                    ngScope().tZip.getData();
                    _vars.isLoading = false;
                });

            } else {
                debug && console.log('Zip code not available. Cannot proceed.');
            }

            $('.spinner').hide();
        });
    }

    this.initMap = function(callback) {

        if (!Microsoft) {
            return;
        }

        dl._vars.map = new Microsoft.Maps.Map(dl._elements.mapPanel, {
            credentials: BingMapKey,
            showDashboard: true,
            showLocateMeButton: false,
            showMapTypeSelector: false,
            enableClickableLogo: false,
            enableSearchLogo: false,
            showCopyright: false,
            showScalebar: false
        });


        //if (localStorageGetItemCommon('_GeoTempLat') && localStorageGetItemCommon('_GeoTempLong')) {
        //    this.centerMap(localStorageGetItemCommon('_GeoTempLat'), localStorageGetItemCommon('_GeoTempLong'));
        //}

        dl._vars.infobox = new Microsoft.Maps.Infobox(new Microsoft.Maps.Location(0, 0), {
            visible: false
        });
        dl._vars.infobox.setMap(dl._vars.map);

        //load other bing modules
        Microsoft.Maps.loadModule("Microsoft.Maps.SpatialMath", function() {

            Microsoft.Maps.loadModule("Microsoft.Maps.Clustering", function() {

                callback && callback();
            });


        });

        Microsoft.Maps.Events.addHandler(dl._vars.map, 'viewchangeend', function(e) {
            dl.onMapMoved(e);
        });

    }

    this.centerMap = function(lat, lon) {
        dl._vars.map.setView({
            center: new Microsoft.Maps.Location(lat, lon)
        });
    }

    this.clearMapPins = function() {
        for (var i = _vars.map.entities.getLength() - 1; i >= 0; i--) {
            var pushpin = _vars.map.entities.get(i);
            if (pushpin instanceof Microsoft.Maps.Pushpin) {
                _vars.map.entities.removeAt(i);
            };
        }
        _vars.map.layers.clear();
        _vars.pushpins = [];
    }

    this.addPinToMap = function(lat, lon, pinNumber, name, distance, carCount, dealerId, dealerHasBuyOnline) {

 if (lat == null || lon == null) return;

        //create pushpin
        var pushpin = new Microsoft.Maps.Pushpin(new Microsoft.Maps.Location(lat, lon));
        pushpin && pushpin.setOptions({
            width: 48,
            height: 48,
            visible: true,
            typeName: pinNumber + '_pin',
            icon: dl._vars.pinIcon,
            text: pinNumber.toString()
        });

        //add other info to pin
        pushpin.metadata = {
            description: '<div data-tap-element-type="map_pin" data-tap-dealer-id="'+dealerId+'" data-tap-dealer-name="'+name+'" data-tap-dealer-distance="'+distance+'" class="map-infobox"><h4>' + name + '</h4><h5 onClick="">' + distance + ' miles away</h5><h5>' + carCount + ' cars</h5> <button type="button" class="btn btn-secondary map-infobox-btn-view-directions" onclick="dl.getDirections(' + lat + ',' + lon + ',\'' + name + '\'); dl.getTracking(\'' + name + '\',\'dealerlocator_map_directions\');">Directions</button></div>',
            pinNumber: pinNumber,
            dealerName: name,
            dealerId: dealerId,
            dealerDistance: distance,
            dealerHasBuyOnline: dealerHasBuyOnline,
        };

        //save to common var
        _vars.pushpins[pinNumber] = pushpin;


        //event handlers -

        //on hover, change icon color and .active corresponding search result
        Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function(e) {
            e.target.setOptions({
                icon: _vars.pinIconActive
            });
            dl.showInfoBox(e.target, false);
        });

        //on hover end, change icon color back and remove .active status from search result
        Microsoft.Maps.Events.addHandler(pushpin, 'mouseout', function(e) {

            if ($('.MicrosoftMap .Infobox:visible').length == 0) {
                e.target.setOptions({
                    icon: dl._vars.pinIcon
                });
            }

            if ((!_vars.infobox.metadata || _vars.infobox.metadata.clicked == false)) {
                dl.hideInfoBox(e.target);
            }
        });

        //on clicking pin, scroll search result to top
        Microsoft.Maps.Events.addHandler(pushpin, 'click', function(e) {
            const { pinNumber, dealerName, dealerId, dealerDistance, dealerHasBuyOnline } = e.target.metadata;
            //tracking
            if(typeof window.TapLocatorMapFuntions === "function") {
                const options = {
                    "context": "map_pin",
                    "dealers_position": pinNumber,
                    "selected_dealer_name": dealerName,
                    "selected_dealer_id": dealerId,
                    "selected_dealer_distance": dealerDistance,
                    "action_label": pinNumber,
                }
                if (dealerHasBuyOnline) {
                    options['options'] = ['buy_online'];
                }                
                window.TapLocatorMapFuntions(options);
            }

            if ($(window).outerWidth() < 768) {
                $('.dl-result[data-pinnumber=' + pinNumber + ']').eq(1).click();
            } else {
                $('.dl-result[data-pinnumber=' + pinNumber + ']').eq(0).click();
            }
        });

        // add pin to map
        _vars.map.entities.push(pushpin);
    }

    //on clicking search result, scroll it to top
    $('body').on('click', '.dl-result', function() {

        var $outer = $(this).closest('.dl-results');
        var scrollTop = $outer.scrollTop() - $outer.offset().top + $(this).offset().top;

        if ($(window).outerWidth() < 768) {

            $("body").animate({
                scrollTop: scrollTop
            }, 250, function() {
                $("body").clearQueue();
            });
        } else {

            $outer.animate({
                scrollTop: scrollTop
            }, 250);
        }
    });

    //make search result .active for a particular pin. 
    //Doesn't show the 'Infobox' now. Using older name without change.
    this.showInfoBox = function(pin, isClicked) {

        //.active search result
        $('.dl-result').removeClass('active')
            .filter('[data-pinnumber=' + pin.metadata.pinNumber + ']').addClass('active');

        for (var i = 0; i < _vars.pushpins.length; i++) {
            var _pin = _vars.pushpins[i];
            _pin && _pin.setOptions({
                icon: _vars.pinIcon
            });
        }

        pin && pin.setOptions({
            icon: _vars.pinIconActive,
        });
    }

    this.hideInfoBox = function(pin) {
        $('.search-result').removeClass('active');

        pin && pin.setOptions({
            icon: _vars.pinIcon,
        });
    }

    this.onMapMoved = function(e) {

        if (dl._vars.isLoading) return;

        //When only the zoom level changed
        var currentZoomLevel = dl._vars.map.getZoom();
        if (dl._vars.lastZoomLevel != currentZoomLevel) {
            dl._vars.lastZoomLevel = currentZoomLevel;
            dl._vars.userChangedZoom = true;

            return;
        }

        if (dl._vars.isRangeSliderChanging == true) {
            //if event was triggered due to slider change, then ignore it
            return;
        }

        var center = dl._vars.map.getCenter();

        dl_getPinCode(center.latitude, center.longitude, function(res, lat, lon, address) {
            debug && console.log(res);

            if (address && address.countryRegion && address.countryRegion != "United States") {
                return;
            }
        });
    }

    //this.refreshData = function (fromCache) {
    //    //clearTimeout(_vars.rangeChangeTimeout);
    //    //_vars.isRangeSliderChanging = true;
    //    //_vars.rangeChangeTimeout = setTimeout(function () {
    //    //    _vars.isRangeSliderChanging = false;
    //    //}, 500);

    //    //if (fromCache !== true) {
    //        var center = _vars.map.getCenter();
    //        dl_getPinCode(center.latitude, center.longitude, function (res) {
    //            angular.element(document.querySelector('#search-radius-slider')).scope().loadDealers(center.latitude, center.longitude, res);
    //        });
    //    //} else {
    //    //    ngScope().filterDealers();
    //    //}
    //}

    // repositions the map when pins are added.
    // doesn't draw any circle. Using older name without change
    this.drawMapCircleRange = function(lat, lon, miles) {

        if (lat == null) {
            var center = _vars.map.getCenter();

            lat = center.latitude;
            lon = center.longitude;
        }

        //calculate lat, lon for correct zoom
        var bounds = [];
        var bound;

        bound = dl.addMilesToLocation(lat, lon, miles);
        bounds.push(new Microsoft.Maps.Location(bound.lat, bound.lon));
        //dl.addPinToMap(bound.lat, bound.lon, 'X');

        bound = dl.addMilesToLocation(lat, lon, miles * -1);
        bounds.push(new Microsoft.Maps.Location(bound.lat, bound.lon));
        //dl.addPinToMap(bound.lat, bound.lon, 'X');

        var bestview = Microsoft.Maps.LocationRect.fromLocations(bounds);
        _vars.map.setView({
            bounds: bestview
        });
    }

    //add miles based on lat lon. Used in above function
    this.addMilesToLocation = function(lat, lon, miles) {
        lat = Number(lat);
        lon = Number(lon);

        var meters = miles * 1609.344;
        var coef = meters * 0.0000089;
        var new_lat = lat + coef;
        var new_long = lon + coef / Math.cos(lat * 0.018);
        var newLoc = {
            lat: new_lat,
            lon: new_long
        };

        return newLoc;
    }

    this.saveLatLong = function(lat, lon) {
        localStorageSetItemCommon("_GeoTempLat", lat);
        localStorageSetItemCommon("_GeoTempLong", lon);
    }


    //autocomplete 
    $('#nameInput').on('focus click', function(e) {
        e.stopPropagation();

        if (ngScope().global.allDealers.length == 0) {
            ngScope().global.getData($('#zipCodeInput').val() || ZipStorage.getZip());
        }

        if ((ngScope().tName.inputName || '').length > 0) {
            $('.search-name-autocomplete').show();
        } else {
            return;
        }

        ngScope().global.filterDealers();
    });

    $('.search-name-autocomplete').on('click', '.search-name-autocomplete-item', function(e) {

        //tracking
        _satellite.track('dealerlocator_search_namesubmit');

        var $e = $(e.target);

        ngScope().tName.inputName = $e.text();
        ngScope().global.filterDealers();

        $('.search-name-autocomplete').hide();

        $('#nameSubmit').click();


    });
    $('body').on('click', function() {
        $('.search-name-autocomplete').hide();
    })
    $('#nameInput').on('input', function() {

        if (($(this).val() || '').length > 0) {
            $('.search-name-autocomplete').show();
        }

        ngScope().global.filterDealers();

        if (ngScope().global.filteredDealers.length == 0) {
            ngScope().global.showTabError(ngScope().tName, 'No results found. Please try again');
        } else {
            ngScope().global.hideTabError(ngScope().tName);
        }
    });

    //detect my location
    $('#dl-geo-mobile').on('click', function() {
        dl_getLocation();
    });
}

//init dl
var dl = new DealerLocator();

//init page. called when bing script is loaded
function initPage() {
    var localStorageZip = ZipStorage.getZip();
    dl.initPage(localStorageZip);
}

$(function() {

    ZipStorage.onZipReady(function() {

        // console.log('app.zipReady triggered');

        var $scope = ngScope();
        var localStorageZip = ZipStorage.getZip();

        $scope.tZip.inputZip = localStorageZip;

        if (!$scope.$$phase) {
            $scope.$apply();
        }

        $scope.global.zipOverlaySubmit()
    });





    $('#zipCodeInput, #dl-no-zip-input, #dl-no-zip-input-mobile, #cityStateInput, #state, #nameInput').on('click', function(e) {

        $(this).removeClass('dl-zip-error');

    });
});


$(function() {
    //sticky map on mobile
    // Check the initial Poistion of the map
    var dlmap = 350; //$('#dl-map').offset().top;

    $(window).scroll(function() {
        //console.log($(window).scrollTop() )

        if ($(window).scrollTop() > dlmap - 50 && $(window).outerWidth() < 768) {
            $('#dl-map').addClass("dl-map-fixed");
        } else {
            $('#dl-map').removeClass("dl-map-fixed");
        }
    });
});


// 2 start ----------------------------------------------------------------------------------------


//returns angular $scope for dlTabController
//moved

// Filter/Format zipcode
// moved

//tabs module
//moved

//Zip tab
//moved

//City-State tab
// moved

//Name tab
//moved


// Filter/Format Phonenumbers
// moved

//only 5 digits for zip input
// moved
 
//auto complete for name search
var ac_ele = {
    input: document.getElementById('nameInput'),
    list: document.getElementById('autocomplete-list')
}

 $(document).ready(function() {
//View inventory click Tracking
    $(document.body).on('click', '.dl-result-btn', function(e) {

       _satellite.track('dealerlocator_results_inventory');
    });


    $(document.body).on('keydown', '.seeMoreBtn', function(e) {
        e.preventDefault();
        if (e.key === 'Enter') {
            $(this).trigger('click');
        }
        
     });


// Input only accept numbers || 'e'

    $("#zipCodeInput").keydown(function (e) {
         // Allow: backspace, delete, tab, escape, enter and .
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
             // Allow: Ctrl+A, Command+A
            (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) || 
             // Allow: home, end, left, right, down, up
            (e.keyCode >= 35 && e.keyCode <= 40)) {
                 // let it happen, don't do anything
                 return;
        }

    //stop 'e'
    if(e.keyCode == 60){e.preventDefault();}
        // Ensure that it is a number and stop the keypress
        if (((e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105 )) {
          $('#output').html(e.keyCode)
            e.preventDefault();
        }
    });


    /* name search auto complete */
    var isHandlingEvent = false;
    ac_ele.input.addEventListener('keydown', function(event) {
    if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (!isHandlingEvent) {
            isHandlingEvent = true;
            var firstOption = ac_ele.list.querySelector('li');
            if (firstOption) {
            firstOption.focus();
            }
            isHandlingEvent = false;
        }
    }
    });

    $(ac_ele.list).on('keydown', function(event) {
        // ac_ele.list.addEventListener('keyup', function(event) {
            var currentOption = document.activeElement;
            var nextOption;
            var lastdirection = 'down';
            event.preventDefault();
            
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                if (!isHandlingEvent) {
                    isHandlingEvent = true;
                    nextOption = currentOption.nextElementSibling;
                    isHandlingEvent = false;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                if (!isHandlingEvent) {
                    isHandlingEvent = true;
                    nextOption = currentOption.previousElementSibling;
                    isHandlingEvent = false;
                    lastdirection = 'up'
                }
            } else if (event.key === 'Enter') {
                $(currentOption).trigger('click');
            }
        
            if (nextOption) {
                currentOption.setAttribute('tabindex', '-1');
                nextOption.focus();
            } else {
                currentOption.setAttribute('tabindex', '-1');
                if (lastdirection === 'down') {
                    nextOption = $('#autocomplete-list li:first');
                } else {
                    nextOption = $('#autocomplete-list li:last');
                }
                // console.log('out range, loop to',nextOption)
                nextOption.focus();
            }
        });


});

// temporarily ignore 404 from endpoints
// tabApp.config(($httpProvider) => {
//     $httpProvider.interceptors.push(function($q) {
//         return {
//             responseError(response) {
//                 if (response.status === 404) {
//                     return response;
//                 }
//             }
//         };
//     });
// });